import { useQuery } from '@tanstack/react-query';

import { fetchIdpDisclaimer } from '../api/fetchIdpDisclaimer.js';
import { dosespotIdpKeys } from './keys.js';

export function idpDisclaimerQueryDefinition() {
  return {
    queryKey: dosespotIdpKeys.disclaimer(),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchIdpDisclaimer(signal),
    meta: {
      toast: {
        title: 'Could not load IDP disclaimer',
        description: 'The identity proofing disclaimer could not be fetched.',
      },
    },
  } as const;
}

export function useIdpDisclaimerQuery(options?: { enabled?: boolean }) {
  return useQuery({
    ...idpDisclaimerQueryDefinition(),
    enabled: options?.enabled,
  });
}
